<div class="debito-warning-modal">
  <div class="titulo">
    <mat-icon color="warn">warning</mat-icon>
    <h2>Débito automático</h2>
  </div>

  <div class="contenido">
    {{ mensaje }}
  </div>

  <div class="acciones">
    <button mat-raised-button color="primary" (click)="cerrar()">Cerrar</button>
  </div>
</div>
